import { c as _c } from "react/compiler-runtime";
import { useEnvironment } from '@/contexts/useEnvironment';

// Each environment reaches its own Temporal UI, and only the browser's host tells the console which
// one it is talking to.
const temporalBaseUrl = (isDev: boolean) => {
  if (isDev) {
    return 'http://localhost:37670';
  }
  if (location.host.endsWith('testing-console.eon.io')) {
    return 'https://temporal.testing-internal.eon.io';
  }
  if (location.host.endsWith('console.app.eon.io')) {
    return 'https://temporal.prod-infra.app.eon.io';
  }
  return 'https://temporal.prod-internal.eon.io';
};
export const useTemporalWorkflowUrl = () => {
  const $ = _c(2);
  const {
    isDev
  } = useEnvironment();
  let t0;
  if ($[0] !== isDev) {
    t0 = (namespace, workflowId) => `${temporalBaseUrl(isDev)}/namespaces/${namespace}/workflows/${workflowId}`;
    $[0] = isDev;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};